import React from 'react';
import VstComponent from './VstComponent';

export default class VstTabBar extends VstComponent {

  render() {
    const maxIndex = this.props.children && this.props.children.length - 1;
    const children = React.Children.map(this.props.children, (child, index) =>
      React.cloneElement(
        child,
        {
          active: index === this.props.activeIndex,
          onClick: () => this.props.onClick(index),
          onPreviousTab: (index > 0 ? () => this.props.onClick(index - 1) : () => {}),
          onNextTab: (index < maxIndex ? () => this.props.onClick(index + 1) : () => {})
        }
      )
    );
    const defaultClass = 'vst-tab-bar';
    const className = this.props.className ? `${defaultClass} ${this.props.className}` : defaultClass;
    return (
      <ul className={className} role="tablist">
        {children}
      </ul>
    );
  }
}

VstTabBar.defaultProps = {
  onClick: () => {}
};
